const FALLBACK_LANGUAGE = 'en';

function getLanguageFromDocument() {
  const lang = document && document.documentElement && document.documentElement.lang;

  if (lang) {
    return lang.replace(/_/g, '-');
  }

  return null;
}

function getLanguage() {
  let lang;

  lang = localStorage.getItem('i18nextLng');
  if (!lang) {
    lang = getLanguageFromDocument();
  }

  if (lang) {
    return lang;
  }

  return FALLBACK_LANGUAGE;
}

export default getLanguage;
